<div class="custom-ribbon-container">
    {{ message }}
</div>
